/* eslint-disable */

import { createGlobalStyle } from 'styled-components';
import { Optimize } from './optimize';

export const GlobalStyle = createGlobalStyle`
  #epgModule {
    ${Optimize};
    line-height: 1.25;
    position: relative;
    z-index: 1105;

    * {
      box-sizing: border-box;
    }
  }
`;
